import { EnumCacheEntityType } from "@/app/services/generated/enums/enumCacheEntityType.generated";
import type { DeliveryArea } from "@/app/services/generated/deliveryareaService";
import { deliveryAreaService } from "@/app/services/generated/deliveryareaService";
import {
  EntityWithGuidKeyCache,
  EntityCacheStore,
} from "@/app/caching/apiCache";

export interface IHasDeliveryAreasCache {
  deliveryAreas: DeliveryAreasCache;
}

// Singleton cache store
const deliveryAreasCacheStore = new EntityCacheStore<DeliveryArea>(
  EnumCacheEntityType.deliveryArea,
  async () => deliveryAreaService.getAllDeliveryAreas()
);

// Ephemeral reader
export default class DeliveryAreasCache extends EntityWithGuidKeyCache<DeliveryArea> {
  constructor() {
    super(deliveryAreasCacheStore, (x) => x.id);
  }
}
